import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
    wrapper2: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    },

    tableOuter: {
        border: '1px solid #E6E7EF',
        borderRadius: 6,
        background: '#fff',
    },

    // BOTH axis scroll
    scrollWrap: {
        maxHeight: 360, // vertical scroll height
        overflow: 'auto', // horizontal + vertical
    },

    table: {
        width: 'max-content', // enables horizontal scroll for many columns
        minWidth: '100%',
        tableLayout: 'fixed', // IMPORTANT for ellipsis consistency
        borderCollapse: 'separate',
    },

    headCell: {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        background: '#F7F8FC',
        fontSize: 12,
        fontWeight: 600,
        color: '#3B3D4A',

        // IMPORTANT for ellipsis (needs constrained width)
        width: 160,
        minWidth: 160,
        maxWidth: 160,

        padding: '8px 12px',
        boxSizing: 'border-box',
    },

    bodyCell: {
        fontSize: 12,
        color: '#5F6071',

        // IMPORTANT for ellipsis (needs constrained width)
        width: 160,
        minWidth: 160,
        maxWidth: 160,

        padding: '8px 12px',
        boxSizing: 'border-box',
    },

    ellipsis: {
        display: 'block',
        maxWidth: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },

    rowHover: {
        '&:hover': {
            background: '#FAFBFF',
        },
    },

    emptyState: {
        padding: '16px',
        color: '#5F6071',
        fontSize: 12,
    },

    // used inside TooltipWrap
    tooltipSpan: {
        display: 'inline-block',
        width: '100%',
    },

    // header styles (moved from inline)
    headerOuter: {
        height: 40,
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    headerInner: {
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        boxSizing: 'border-box',
    },
    headerBar: {
        height: 20,
        width: 2,
        backgroundColor: '#3F51B5',
    },
    headerTitle: {
        fontSize: 14,
        fontWeight: 400,
        color: '#5F6071',
        fontStyle: 'normal',
        lineHeight: '24px',
        whiteSpace: 'nowrap',
    },
    downloadIconBtn: {
        padding: 4,
    },
    downloadImg: {
        width: 18,
        height: 18,
        display: 'block',
    },
}))
